export default "__VITE_ASSET__823ebb83__"